import { render, staticRenderFns } from "./TableItem1.vue?vue&type=template&id=5d66cde4&scoped=true"
import script from "./TableItem1.vue?vue&type=script&lang=js"
export * from "./TableItem1.vue?vue&type=script&lang=js"
import style0 from "./TableItem1.vue?vue&type=style&index=0&id=5d66cde4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d66cde4",
  null
  
)

export default component.exports